<div class="columns is-multiline">
  @if (apoderado().associatedClientName) {
    <app-constitution-readonly-field label="Cliente" [value]="apoderado().associatedClientName" colSize="12" />
  }
  <app-constitution-readonly-field label="Nombre" [value]="apoderado().nombre" colSize="12" />
  <app-constitution-readonly-field label="NIF" [value]="apoderado().nif" colSize="12" />
  <app-constitution-readonly-field
    label="Tipo de responsabilidad"
    [value]="apoderado().tipoPoder"
    colSize="12"
  />
  @if (apoderado().responsibilityTypeRaw === 'RESPONSIBILITY_ESPECIAL') {
    <app-constitution-readonly-field
      label="Resumen de poderes"
      [value]="apoderado().specialResponsibilitySummary"
      colSize="12"
      [multiline]="true"
    />
  }
  <app-constitution-readonly-field
    label="Fecha de alta del poder"
    [value]="apoderado().fechaAlta"
    colSize="6"
  />
  <app-constitution-readonly-field
    label="Fecha de baja"
    [value]="apoderado().fechaBaja"
    colSize="6"
  />
</div>
